import React from 'react';

export const orderCashReplenishmentConfig = [
  {
    path: '/order',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/order/rincian-order-cash-replenishment',
    component: React.lazy(() =>
      import('./rincianOrderReplenishment/rincianOrderReplenishment'),
    ),
  },
  // {
  //   path: '/order-cash-movement/detail-rincian-order-cash-movement',
  //   component: React.lazy(() => import('./detail/detail')),
  // },
];
